// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import FrenchGuiana from '../_raw/flag/icon_flag_french_guiana.png';

export default () => <img src={FrenchGuiana} alt="FrenchGuiana" />;
